import React from 'react'
import Modal from 'react-bootstrap/lib/Modal.js'
import Iframe from "react-iframe";
class ModalActaCliente extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }

    componentDidMount() {
        this.props.previewActa(this.props.idInventario)
    }

    render() {

        return (
            <Modal show={this.props.showModal} onHide={this.props.cancelModal} bsSize='large'>
                <Modal.Header closeButton>
                    <Modal.Title>Acta Inventario</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ width: '100%', height: '70vh', margin: 'auto' }}>
                        <iframe
                            src={this.props.indicators}
                            width='100%'
                            height='100%'
                            style={{ display: 'block', border: 'none' }}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <a className="btn btn-primary" href={`/inventario/archivo-final/${this.props.indicators.id_file}/descargar-acta`} target='_blank'>
                        Descargar Acta
                    </a>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default ModalActaCliente


// WEBPACK FOOTER //
// ./frontEnd/home/components/ModalActaCliente.jsx